import { render } from "./QuickSellOrderDetails.vue?vue&type=template&id=2da3eba4&scoped=true"
import script from "./QuickSellOrderDetails.vue?vue&type=script&lang=js"
export * from "./QuickSellOrderDetails.vue?vue&type=script&lang=js"

import "./QuickSellOrderDetails.vue?vue&type=style&index=0&id=2da3eba4&lang=less&scoped=true"

import exportComponent from "/data/web/pay/brpay/brpay-h5/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2da3eba4"]])

export default __exports__